// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionCircleOutlinedSvg from "@fishx/icons-svg/es/asn/QuestionCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleOutlinedSvg
  }));
};

QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
export default React.forwardRef(QuestionCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QuestionCircleOutlined.js
// module id = 3954
// module chunks = 0